import { DataLoadedStatus, SectionStatusType } from '../../types';
import { AntimalwareSettingsSectionState } from './antimalware.types';

export const defaultAntimalwareSettingsState: AntimalwareSettingsSectionState = {
  isValid: true,
  status: { type: SectionStatusType.NONE },
  additionalInfo: {
    exclusionsListsLoaded: DataLoadedStatus.NOT_LOADED,
    vendorsExclusionsListsLoaded: DataLoadedStatus.NOT_LOADED,
  },
};
